module.exports = __webpack_public_path__ + "static/media/logo_jiotogether.5cce1282.svg";